<template>
  <v-flex xs12 class="align-self-stretch pb-5">
    <v-toolbar dense flat v-if="tab !== 5" class="transparent">
      <v-spacer></v-spacer>
      <v-toolbar-title>Panou de control</v-toolbar-title>
      <!-- <v-btn flat @click="toggleDisplay" v-tooltip:left="{ html: display.label }">
        <v-icon :primary="display.icon === 'list'">list</v-icon>
        <v-icon>swap_horiz</v-icon>
        <v-icon :primary="display.icon === 'grid_on'">grid_on</v-icon>
      </v-btn> -->
      <v-spacer></v-spacer>
    </v-toolbar>


    <tud-users-card :display="display" v-if="tab === 1"></tud-users-card>
    <tud-addresses-card :display="display" v-if="tab === 2"></tud-addresses-card>
    <tud-requests-card :display="display" v-if="tab === 3"></tud-requests-card>
    <tud-statuses-card :display="display" v-if="tab === 4"></tud-statuses-card>
    <tud-map-card-users v-if="tab === 5"></tud-map-card-users>
    <tud-map-card-addr v-if="tab === 6"></tud-map-card-addr>
    <tud-archives-card :display="display" v-if="tab === 7"></tud-archives-card>

    <v-bottom-nav shift value="true" class="primary">
      <v-btn :value="tab === 1" @click="tab = 1" class="white--text">
        <span>Utilizatori</span>
        <v-icon>person</v-icon>
      </v-btn>
      <v-btn :value="tab === 2" @click="tab = 2" class="white--text">
        <span>Adrese</span>
        <v-icon>location_on</v-icon>
      </v-btn>
      <v-btn :value="tab === 3" @click="tab = 3" class="white--text">
        <span>Cereri de access</span>
        <v-icon>lock</v-icon>
      </v-btn>
      <v-btn :value="tab === 4" @click="tab = 4" class="white--text">
        <span>Satus utilizatori</span>
        <v-icon>person_pin</v-icon>
      </v-btn>
      <v-btn :value="tab === 5" @click="tab = 5" class="white--text">
        <span>Useri</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn :value="tab === 6" @click="tab = 6" class="white--text">
        <span>Adrese</span>
        <v-icon>map</v-icon>
      </v-btn>
      <v-btn :value="tab === 7" @click="tab = 7" class="white--text">
        <span>Arhive</span>
        <v-icon>file_download</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-flex>
</template>

<script>
export default {
  components: {
    'tud-users-card': () => import('@/components/admin/UsersCard.vue'),
    'tud-addresses-card': () => import('@/components/admin/AddressesCard.vue'),
    'tud-requests-card': () => import('@/components/admin/RequestsCard.vue'),
    'tud-statuses-card': () => import('@/components/admin/StatusesCard.vue'),
    'tud-map-card-users': () => import('@/components/admin/MapCardUsers.vue'),
    'tud-map-card-addr': () => import('@/components/admin/MapCardAddr.vue'),
    'tud-archives-card': () => import('@/components/admin/ArchivesCard.vue')
  },
  data () {
    return {
      tab: 1,
      display: {
        mode: 'list',
        icon: 'list',
        label: 'Display (*lista / tabel)'
      }
    }
  },
  computed: {
    light () {
      return this.$store.getters.appLight
    }
  },
  methods: {
    toggleDisplay () {
      this.display.mode = this.display.mode === 'list' ? 'table' : 'list'
      this.display.icon = this.display.icon === 'list' ? 'grid_on' : 'list'
      this.display.label = `Layout (${this.display.mode === 'list' ? '*lista / tabel' : 'lista / *tabel'})`
    }
  }
}
</script>

<style lang="stylus">
  .bottom-nav {
    left: 0;
    .btn {
      max-width: calc(100% / 6);
      .btn__content {
        width: 100%;
        padding: 0;

        span {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .admin-items-card {
    overflow: hidden;
    .card-list .list__tile__action {
      min-width: min-content;
    }
  }

  .card-navigation.pagination {
    height: 56px;
    .pagination__navigation {
      box-shadow: none;
      .icon {
        font-size: 1.4rem;
      }
    }

    .pagination__item {
      font-size: .8rem;
      width: calc(14px + .8rem);
      height: calc(14px + .8rem);
      box-shadow: none;
    }

    .pagination__item--active {
      box-shadow: none;
    }
  }

  .application--dark {
    table.table tbody tr:hover {
      background-color: #616161!important
    }

    .card-navigation.pagination {
      .pagination__navigation {
        .icon {
          color: white;
        }
      }

      .pagination__item {
        color: white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?275c8566